//#region src/olo_set_table_number_as.ts
let OloSetTableNumberAs = /* @__PURE__ */ function(OloSetTableNumberAs) {
	OloSetTableNumberAs["TableNumber"] = "table-number";
	OloSetTableNumberAs["OrderNumber"] = "order-number";
	return OloSetTableNumberAs;
}({});
//#endregion
export { OloSetTableNumberAs };

//# sourceMappingURL=olo_set_table_number_as.js.map